/** *********************************************************************
 * ログを出力するライブラリ
 *  メッセージタイプ|処理
 *  info|すべて出力
 *  warm|STAGE=devのみ出力
 *  debug|STAGE=devのみ出力
 *  error|すべて出力 & Slack通知
 ********************************************************************** */
// import { WebClient } from '@slack/web-api';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(timezone);
dayjs.extend(utc);

export default class Log {
  // 型宣言
  stage: 'dev' | 'prod'
  fileName: string
  // コンストラクタ
  constructor(fileName: string) {
    // 環境変数の読み込み
    // const { SLACK_BOT_USER_TOKEN, SLACK_CHANNEL } = process.env;
    // クライアントの準備
    // this.slackClient = new WebClient(SLACK_BOT_USER_TOKEN);
    // チャンネルの設定
    // this.channel = SLACK_CHANNEL;
    // ステージの設定
    this.stage = process.env.REACT_APP_STAGE || 'dev';
    // console.log(`🥷 Log initialized. [${this.stage}]`);
    // ファイル名
    this.fileName = `@${fileName}`;
  }

  /**
   *
   * @param {String} type ログのタイプ（'info','debug','error'）
   * @param {String} message 出力するメッセージ
   */
  async putLog(type: string, message: string|undefined) {
    const now = dayjs()
      .tz('Asia/Tokyo')
      .format('HH:mm:ss');
    let output;
    switch (type) {
      case 'info':
        output = `🐷 ${this.fileName} [${now}] - ${message}`;
        console.log(output);
        break;
      case 'warm':
        output = `🐶 ${this.fileName} [${now}] - ${message}`;
        if (this.stage === 'dev') console.log(output);
        break;
      case 'debug':
        output = `👽 ${this.fileName} [${now}] - ${message}`;
        if (this.stage === 'dev') console.log(output);
        break;
      case 'error':
        output = `👺 ${this.fileName} [${now}] - ${message}`;
        // await this.postSlackMessage(output);
        console.log(output);
        break;
      default:
        output = `🐞 ${this.fileName} [${now}] - ${message}`;
        console.log(output);
        break;
    }
  }
  /**
   * メッセージをPOSTする
   * @param {String} message POSTするメッセージ
   */
  // async postSlackMessage(message) {
  //   try {
  //     await this.slackClient.chat.postMessage({
  //       channel: this.channel,
  //       text: message,
  //     });
  //   } catch (err) {
  //     console.error(
  //       `👺 ERROR in postSlackMessage: ${err.message ? err.message : err}`,
  //     );
  //   }
  // }
}
